import { ThemeMenu } from '@/components/theme/ThemeMenu'
import { Menu } from 'lucide-react'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import { ConfigMenu } from './ConfigMenu'
import { HeaderAccountMenu } from './HeaderAccountMenu'
import { DrawIconButton, docsDrawIcon } from '@/components/ui/DrawIconButton'

interface HeaderProps {
  /** Opens the side navigation; a page without one (such as the account pages) leaves it out, and no menu button shows. */
  onOpenNavigation?: (() => void) | undefined
}

export function Header({ onOpenNavigation }: HeaderProps) {
  const location = useLocation()
  const navigate = useNavigate()
  return (
    <header className="fixed inset-x-0 top-0 z-50 flex h-16 items-center border-b border-border-default bg-canvas px-4">
      <Link
        to="/"
        className="flex min-w-0 shrink-0 items-center gap-2 no-underline transition-opacity hover:opacity-80"
      >
        <img
          src="/assets/justlogo.png"
          alt="ForgeSphere logo"
          className="h-11 w-auto"
        />
        <span className="flex h-11 flex-col justify-center overflow-hidden max-[380px]:hidden">
          <span className="text-[0.65rem] leading-tight whitespace-nowrap text-muted">
            ProbeStack
          </span>
          <span className="font-heading gradient-text text-lg leading-tight font-extrabold whitespace-nowrap sm:text-xl">
            ForgeSphere
          </span>
        </span>
      </Link>

      <div className="flex-1" />
      <div className="flex items-center gap-1.5 sm:gap-2">
        <DrawIconButton
          icon={docsDrawIcon}
          label="Docs"
          tooltip="Documentation for this page"
          onClick={() =>
            navigate(`/docs${location.pathname}${location.search}`)
          }
        />
        <div className="flex items-center gap-1.5 rounded-xl  bg-surface/50 p-1">
          <div className="hidden lg:block">
            <ThemeMenu />
          </div>
          <ConfigMenu />
        </div>
        <div
          className="mx-1 hidden h-6 w-px bg-border-default lg:block"
          aria-hidden="true"
        />
        <HeaderAccountMenu />
      </div>

      {onOpenNavigation && (
        <button
          type="button"
          aria-label="Open navigation menu"
          className="ml-1.5 grid size-8 shrink-0 place-items-center rounded-lg border border-border-default bg-raised/60 text-primary transition hover:border-accent-border/50 hover:bg-raised sm:ml-2 lg:hidden"
          onClick={onOpenNavigation}
        >
          <Menu size={18} aria-hidden="true" />
        </button>
      )}
    </header>
  )
}
